import { render, staticRenderFns } from "./AnalyseBase.vue?vue&type=template&id=9f64ff5c"
import script from "./AnalyseBase.vue?vue&type=script&lang=js"
export * from "./AnalyseBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports